/* ═══════════════════════════════════════════════════════════════
   Org Chart V2 — junction right-click menu. Small, viewport-clamped,
   portal-free (fixed positioning like the sibling menus — dismissed
   by OrgChartV2's shared mousedown-outside/Esc handler via
   data-orgchart-menu). Josh law 2026-08-17: right-clicking a junction
   used to delete it instantly; it's now a real menu. Only item for
   now — "Delete junction".
   ═══════════════════════════════════════════════════════════════ */

import React from 'react';
import { Trash2 } from 'lucide-react';
import { Icon } from '../../../../components/ui/Icon';
import { rem } from '../../../../lib/rem';

export interface JunctionMenuProps {
  x: number;
  y: number;
  onDeleteJunction: () => void;
  onClose: () => void;
}

const MENU_W = 180;

export function JunctionMenu({ x, y, onDeleteJunction, onClose }: JunctionMenuProps) {
  const menuX = Math.min(Math.max(8, x), window.innerWidth - MENU_W - 8);
  const menuY = Math.min(Math.max(8, y), window.innerHeight - 56);

  return (
    <div
      data-orgchart-menu
      role="menu"
      aria-label="Junction options"
      style={{
        position: 'fixed',
        left: menuX,
        top: menuY,
        background: 'var(--sf)',
        border: '1px solid var(--bd)',
        borderRadius: rem(8),
        boxShadow: '0 8px 24px rgba(0,0,0,.18)',
        padding: 'var(--space-1) 0',
        width: MENU_W,
        zIndex: 1000,
      }}
    >
      <button
        onClick={() => {
          onClose();
          onDeleteJunction();
        }}
        title="Delete this junction and the lines connected to it"
        aria-label="Delete junction"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-2)',
          width: '100%',
          minHeight: 'var(--space-6)',
          textAlign: 'left',
          padding: `${rem(7)} ${rem(14)}`,
          fontSize: 'var(--font-size-base)',
          fontWeight: 500,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--dg)',
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = 'color-mix(in srgb, var(--dg) 12%, transparent)')
        }
        onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
      >
        <Icon icon={Trash2} em={1.0769} aria-hidden="true" />
        Delete junction
      </button>
    </div>
  );
}
